import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateRfqNamePayload = {
  rfq_id: number;
  name: string;
};

export type UpdateRfqNameResponse = {
  rfq: {
    id: number;
    document: {
      name: string;
      [key: string]: any;
    };
    [key: string]: any;
  };
};

export const updateRfqName = async (
  payload: UpdateRfqNamePayload
): Promise<UpdateRfqNameResponse> => {
  try {
    const { data } = await apiService.patch(`/rfqs/${payload.rfq_id}`, {
      document: {
        name: payload.name
      }
    });

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
